/**
 * Singleton ImageUploadService instance wired to the real SQLite storage.
 *
 * Separated from the service class so the class stays testable with mock storage.
 */

import {
  deleteImageUploadItem,
  enqueueImageUpload,
  getNote,
  getPendingImageUploads,
  incrementImageUploadRetries,
  markFailedImageUploads,
  updateImageUploadStatus,
  updateNote,
} from '../db'
import { useAuthStore } from '../../store/auth'
import { API_URL, MAX_FILE_SIZE } from '../attachments'
import { ImageUploadService, type ImageQueueStorage } from './imageUploadService'

const storage: ImageQueueStorage = {
  enqueue: enqueueImageUpload,
  getPending: getPendingImageUploads,
  updateStatus: updateImageUploadStatus,
  incrementRetries: incrementImageUploadRetries,
  deleteItem: deleteImageUploadItem,
  markFailed: markFailedImageUploads,
  getNote: (id: string) => {
    const note = getNote(id)
    if (!note) return undefined
    return { content: note.content }
  },
  updateNoteContent: (id: string, content: string) => {
    updateNote(id, {
      content,
      updatedAt: new Date().toISOString(),
    })
  },
}

let _instance: ImageUploadService | null = null

export function getImageUploadService(): ImageUploadService {
  if (!_instance) {
    _instance = new ImageUploadService({
      storage,
      apiUrl: API_URL,
      maxFileSize: MAX_FILE_SIZE,
      isSignedIn: () => useAuthStore.getState().user !== null,
    })
  }
  return _instance
}
